import type { ApiErrorCause } from "./errorHandling/parseApiError";

/** Mirrors ``MAX_NAME_CHARS`` in the API's grid-views repository. */
export const GRID_VIEW_NAME_MAX_LENGTH = 80;

/** A thrown api-client error carrying a 409 means the name is already taken. */
export function isDuplicateGridViewNameError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const cause = error.cause as ApiErrorCause | undefined;
  return cause?.status === 409;
}
